import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@cmps/ng-bootstrap';
import { NgChartModule } from '@cmps/ng-chart';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonModule,
    CmpsChipModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsPortalModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';

import { FLWinningComponent } from './fl-winning.component';
import { TranslationIdMap } from './fl-winning.i18n';
import { FractionBarWinningComponent } from './fraction-bar-wp.component';
import { FLWinningPersonRowComponent } from './frontline-person/fl-winning-person-row.component';

@NgModule({
    declarations: [
        FLWinningComponent,
        FLWinningPersonRowComponent,
        FractionBarWinningComponent,
    ],
    exports: [FLWinningComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        SelectModule,
        NgChartModule,
        CommonModule,
        CmpsCommonModule,
        CmpsChipModule,
        CmpsButtonModule,
        CmpsFilterModule,
        CmpsPortalModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTooltipModule,
    ],
})
export class CmpsFLWinningModule {}
